import AccountManagerCalendarApi from 'client/api/v2/AccountManagerCalendarApi';
import Vue from 'vue';

export const initialState = () => ({
  scheduleSalesUrl: {
    name: '',
    publicCalendarUrl: '',
  },
});

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async fetchAccountManagerCalendarUrl({ commit }, orgId) {
      const resp = await AccountManagerCalendarApi.fetch(orgId);
      if (resp) {
        commit('SET_SCHEDULE_SALES_CALL', resp.data);
      }
    },
  },

  getters: {
    getAccountManagerCalendarUrl(state) {
      return state.scheduleSalesUrl.publicCalendarUrl;
    },
  },

  mutations: {
    SET_SCHEDULE_SALES_CALL(state, scheduleSalesUrl) {
      Object.keys(state.scheduleSalesUrl).forEach((field) => {
        Vue.set(state.scheduleSalesUrl, field, scheduleSalesUrl[field]);
      });
    },
  },
};
